import React, { useState } from 'react'
import { useDisclosure } from '@chakra-ui/react'
import { FiPlus } from 'react-icons/fi'
import useRoleAccessContext from 'containers/RoleAccess/useRoleAccessContext'

import { Box } from 'components/Layout'
import Modal from 'components/Modal'
import Table from 'components/Table'
import Button from 'components/Button'
import PageWrapper from 'layout/PageWrapper'
import { generateFormData } from 'utils/helpers'
import useRoutePagination from 'utils/hooks/useRoutePagination'
import Pagination from 'components/Pagination'
import useToast from 'utils/hooks/useToast'
import TableHeader from 'components/Table/TableHeader'
import Create from './Forms/Create'

import { columns } from './columns'
import {
  useCommitteeMeetingMinutes,
  useMutateCommitteeMeetingMinutes
} from './api'
import { CommitteeMeetingMinutesProvider } from './Context'
import { useCommittee } from '../Archived/api'

const CommitteeMeetingMinutes = () => {
  const toast = useToast()
  const [year, setYear] = useState(null)
  const [search, setSearch] = useState(null)
  const { access = [] } = useRoleAccessContext()
  const { page, ...pageProps } = useRoutePagination()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [contentState, setContentState] = React.useState()
  const [committeeData, setCommitteeData] = React.useState('')
  const {
    committeeMeetingMinutes = {},
    committeeMeetingMinutesIsLoading,
    committeeMeetingMinutesRevalidate
  } = useCommitteeMeetingMinutes({
    page,
    year,
    search,
    committeeData
  })
  const { committee } = useCommittee()
  const { data, totalPages } = committeeMeetingMinutes

  const { createCommitteeMeetingMinutes } =
    useMutateCommitteeMeetingMinutes()

  const handleCreateMinutes = async (formValues) => {
    const { file = [], committeeId, ...rest } = formValues

    const payload = {
      file: file && file.length > 0 ? file[0] : null,
      committeeId: JSON.stringify(committeeId),
      ...rest
    }
    await createCommitteeMeetingMinutes(
      generateFormData(payload)
    )

    toast({
      title: 'Draft document created.',
      status: 'success',
      description: "We've created your draft document."
    })
    committeeMeetingMinutesRevalidate()
    onClose()
    setContentState(undefined)
  }

  return (
    <CommitteeMeetingMinutesProvider
      value={{ revalidate: committeeMeetingMinutesRevalidate }}
    >
      <Box>
        <PageWrapper
          headerRightComponent={
            access['committee-meeting-minutes'] &&
            access['committee-meeting-minutes'].includes(
              'create'
            ) ? (
              <Button
                leftIcon={<FiPlus />}
                onClick={() => onOpen()}
              >
                New Committee Meeting Minutes
              </Button>
            ) : (
              false
            )
          }
        >
          <TableHeader
            onSearch={setSearch}
            setYear={setYear}
            setCommitteeData={setCommitteeData}
            committeeData={committee}
            year={[
              {
                label: 1999,
                value: 1999
              },
              {
                label: 2000,
                value: 2000
              },
              {
                label: 2001,
                value: 2001
              },
              {
                label: 2002,
                value: 2002
              },
              {
                label: 2003,
                value: 2003
              },
              {
                label: 2004,
                value: 2004
              },
              {
                label: 2005,
                value: 2005
              },
              {
                label: 2006,
                value: 2006
              },
              {
                label: 2007,
                value: 2007
              },
              {
                label: 2008,
                value: 2008
              },
              {
                label: 2009,
                value: 2009
              },
              {
                label: 2010,
                value: 2010
              },
              {
                label: 2011,
                value: 2011
              },
              {
                label: 2012,
                value: 2012
              },
              {
                label: 2013,
                value: 2013
              },
              {
                label: 2014,
                value: 2014
              },
              {
                label: 2015,
                value: 2015
              },
              {
                label: 2016,
                value: 2016
              },
              {
                label: 2017,
                value: 2017
              },
              {
                label: 2018,
                value: 2018
              },
              {
                label: 2019,
                value: 2019
              },
              {
                label: 2020,
                value: 2020
              },
              {
                label: 2021,
                value: 2021
              },
              {
                label: 2022,
                value: 2022
              },
              {
                label: 2023,
                value: 2023
              },
              {
                label: 2024,
                value: 2024
              },
              {
                label: 2025,
                value: 2025
              },
              {
                label: 2026,
                value: 2026
              },
              {
                label: 2027,
                value: 2027
              },
              {
                label: 2028,
                value: 2028
              },
              {
                label: 2029,
                value: 2029
              },
              {
                label: 2030,
                value: 2030
              }
            ]}
          />
          <Table
            isLoading={committeeMeetingMinutesIsLoading}
            data={data}
            columns={columns}
          />
          {data && (
            <Pagination
              {...pageProps}
              totalPages={totalPages}
              page={page}
              nextDisabled={totalPages === page}
            />
          )}
        </PageWrapper>

        <Modal
          title="Create Committee Meeting Minutes"
          isOpen={isOpen}
          size="5xl"
          onClose={onClose}
          withActionButtons={false}
          closeOnOverlayClick={false}
        >
          <Create
            contentState={contentState}
            setContentState={setContentState}
            onClose={onClose}
            onSubmit={handleCreateMinutes}
          />
        </Modal>
      </Box>
    </CommitteeMeetingMinutesProvider>
  )
}

export default React.memo(CommitteeMeetingMinutes)
